export const clearMediaSession = () => {
  if ('mediaSession' in navigator) {
    try {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: '',
        artist: '',
        album: '',
        artwork: []
      })

      const actions: MediaSessionAction[] = [
        'play',
        'pause',
        'seekbackward',
        'seekforward',
        'previoustrack',
        'nexttrack'
      ]

      actions.forEach((action) => {
        try {
          navigator.mediaSession.setActionHandler(action, null)
        } catch (err) {
          console.warn(`[MediaSession] Failed to clear handler: ${action}`, err)
        }
      })
    } catch (err) {
      console.warn('[MediaSession] Failed to clear media session:', err)
    }
  }
}
